export default __webpack_public_path__ + "static/media/pb40.a0bba1a9.png";